export default "__VITE_ASSET__DPZGB1gq__"